module.exports = __webpack_public_path__ + "static/img/btt3.b81c598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btt3.png
// module id = IY2r
// module chunks = 1